import { useEffect, useState } from "react";
import { Download, ChevronLeft, ChevronRight } from "lucide-react";
import { API } from "../../lib/api";
import { fmtDate } from "../../lib/format";
import { PageHeader, Loading, Table, Empty } from "../../components/common";

export default function AdminAudit() {
  const [data, setData] = useState(null);
  const [page, setPage] = useState(1);
  const [search, setSearch] = useState("");

  const load = () => API.get(`/admin/audit-logs?page=${page}&search=${encodeURIComponent(search)}`).then((r) => setData(r.data));
  useEffect(() => { load(); }, [page]);
  useEffect(() => { const t = setTimeout(() => { setPage(1); load(); }, 350); return () => clearTimeout(t); }, [search]);

  return (
    <div data-testid="admin-audit">
      <PageHeader title="Audit Logs" sub="Every sensitive action — recorded with user, before/after values, IP, and timestamp."
        right={<a className="btn-outline-gov" href={`${process.env.REACT_APP_BACKEND_URL}/api/admin/audit-logs?format=csv`} data-testid="audit-export"><Download className="h-4 w-4" /> Export CSV</a>} />

      <input className="input-gov mb-4 max-w-sm" placeholder="Search user, action, record…" value={search} onChange={(e) => setSearch(e.target.value)} data-testid="audit-search" />

      {!data ? <Loading label="Loading audit logs" /> : data.items.length === 0 ? <Empty title="No audit entries" /> : (
        <>
          <Table headers={["Timestamp", "User", "Role", "Action", "Record", "IP", "Details"]} testid="audit-table">
            {data.items.map((a) => (
              <tr key={a.id} className="border-b border-slate-100">
                <td className="px-4 py-2.5 whitespace-nowrap text-xs text-slate-500">{fmtDate(a.created_at)}</td>
                <td className="px-4 py-2.5 text-sm">{a.user_email}</td>
                <td className="px-4 py-2.5 text-xs text-slate-400">{a.user_role}</td>
                <td className="px-4 py-2.5 font-mono text-xs font-semibold text-navy">{a.action}</td>
                <td className="px-4 py-2.5 text-xs text-slate-500">{a.record_type || "—"}</td>
                <td className="px-4 py-2.5 text-xs text-slate-400">{a.ip || "—"}</td>
                <td className="max-w-xs truncate px-4 py-2.5 text-xs text-slate-400" title={JSON.stringify({ prev: a.previous_value, new: a.new_value })}>
                  {a.new_value ? JSON.stringify(a.new_value).slice(0, 80) : "—"}
                </td>
              </tr>
            ))}
          </Table>
          <div className="mt-4 flex items-center justify-between">
            <span className="text-sm text-slate-500">{data.total} entries</span>
            <div className="flex gap-2">
              <button className="btn-outline-gov px-3 py-1.5" disabled={page <= 1} onClick={() => setPage(page - 1)} data-testid="audit-prev"><ChevronLeft className="h-4 w-4" /></button>
              <button className="btn-outline-gov px-3 py-1.5" disabled={page >= data.pages} onClick={() => setPage(page + 1)} data-testid="audit-next"><ChevronRight className="h-4 w-4" /></button>
            </div>
          </div>
        </>
      )}
    </div>
  );
}
